<!-- Translated: skip -->
<template>
  <Modal @close="closeModal" :wide="false" width="540px">

    <div class="keycard-splasch" v-if="SITE_CONFIG.accomodations.skipass_currently_discounted">Just nu <div class="larger">10% rabatt*</div></div>

    <h2 class="center">Boka liftkort<br></h2>

    <Loading :show="loading" />

    <div class="skipass-holder">

      <div class="image">
      </div>

      <div class="padded">
        <ul>
          <li>Enkelt! Liftkort för hela vistelsen.</li>
          <li>Smidigt! Liftkorten klara vid ankomst.</li>
          <li>Snabbt! Åk direkt ut i backen.</li>
        </ul>
      </div>
    </div>

    <div :class="'center ' + (loading ? 'disabled' : '')" v-if="!skipassBlocked">
      <div class="">

        <table class="skipass-table">
          <tr>
            <th colspan="3" v-if="cartAccomodationObject.period">
              {{cartAccomodationObject.period.date_arrival}} - {{cartAccomodationObject.period.date_departure}} <span>({{noOfDays()}} dagar)</span>
            </th>
          </tr>
          <tr>
            <td>
              <input type="number" v-model="cartSkipassObject.adults" :readonly="cartSkipassObject.confirmed">
            </td>
            <td>
              Vuxna
            </td>
            <td>
              <b v-if="!loading">{{adultPrice(false) | currency}}</b>
            </td>
          </tr>
          <tr>
            <td>
              <input type="number" v-model="cartSkipassObject.youths" :readonly="cartSkipassObject.confirmed">
            </td>
            <td>
              Ungdom
            </td>
            <td>
              <b v-if="!loading">{{youthPrice(false) | currency}}</b>
            </td>
          </tr>
          <tr v-if="this.seniorPricelistPrice">
            <td>
              <input type="number" v-model="cartSkipassObject.seniors" :readonly="cartSkipassObject.confirmed">
            </td>
            <td>
              Senior
            </td>
            <td>
              <b v-if="!loading">{{seniorPrice(false) | currency}}</b>
            </td>
          </tr>
          <tr>
            <td>
              <input type="number" v-model="cartSkipassObject.children" :readonly="cartSkipassObject.confirmed">
            </td>
            <td>
              Barn
            </td>
            <td :class="{'children-price': !childPrice(false)}">
              <b v-if="!loading">{{ childPrice(false) | currency({freeIfZero: true})}}</b>
            </td>
          </tr>
          <tr>
            <td>
              <input type="number" readonly :value="noOfSkipasses()">
            </td>
            <td>
              Liftkort
            </td>
            <td :class="{'children-price': (!keycardTotalPrice() && parseInt(cartSkipassObject.children, 10))}">
              <b v-if="!loading">{{ keycardTotalPrice() | currency({freeIfZero: true})}}</b>
            </td>
          </tr>
          <tr class="summarizer" v-if="!loading">
            <td colspan="2">
              <span v-if="( originalPrice() > totalPrice() ) && SITE_CONFIG.accomodations.skipass_currently_discounted">
                <span class="smaller">Ord pris:</span> {{originalPrice() | currency}}
              </span>
            </td>
            <td>
              <div class="offsetter">
                <span>Totalt pris</span>&nbsp;<b>{{totalPrice() | currency}}</b>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div style="clear:both;"></div>

    </div>

    <div :class="'space center info-wrapper ' + (loading ? 'disabled' : '')" v-if="!skipassBlocked">
      <div v-if="FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')">
        <h2 class="center">När ska liftkorten börja användas?<br></h2>

        <Checkbox :disabled="!deliveryAllowed" label-position="after" label="" :sublabel=skiPassAccomodationAfterCheckinText :value="'delivery'" :valuebinder.sync="delivery_type" :size="24" :below="true" />

        <Checkbox label-position="after" label="" :sublabel=skiPassAccomodationBeforeCheckinText :value="'pickup'" :valuebinder.sync="delivery_type" :size="24" :below="true" />
      </div>

      <div v-if="FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')">
        <h2 class="center" v-html="SETTING('SettingSkipassMachineInfo').title + '<br />'"></h2>
        <p v-bind:key="index" v-for="(paragraph, index) in SETTING('SettingSkipassMachineInfo').paragraphs" v-html="paragraph"></p>
        <!-- <p>Vill du hellre få liftkorten tillsammans med din förbokade utrustning? Inga problem, välj inga liftkort här, utan gör det när du bokar utrustning i stället.</p> -->
      </div>

      <div v-if="FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines') && delivery_type === 'pickup'">
        <hr />

        <h2 class="center">Var vill du hämta liftkorten?<br></h2>

        <Checkbox label-position="after" label="" sublabel="Dalen" :value="'by'" :valuebinder.sync="site" :size="24" :below="true" />

        <Checkbox label-position="after" label="" sublabel="Berget" :value="'berg'" :valuebinder.sync="site" :size="24" :below="true" />
      </div>
    </div>

    <div class="space center bt-wrapper" v-if="!skipassBlocked">
      <button :class="'no-hover ' + (loading ? 'disabled' : '')" @click="cartSkipasses()" :disabled="!validatedSkipasses()" v-if="!cartSkipassObject.confirmed">Ja, Förboka och spara tid</button>

      <button :class="'small-key ' + (loading ? 'disabled' : '')" @click="closeModal()" v-if="!cartSkipassObject.confirmed">Nej, bokar senare</button>
      <button class="small green" @click="removeSkipasses()" v-if="cartSkipassObject.confirmed">{{noOfSkipasses()}} st valda</button>
      <button class="small trash border" @click="removeSkipasses()" v-if="cartSkipassObject.confirmed"><icon name="trash" :scale="1.7" /></button>
    </div>

    <div v-if="SITE_CONFIG.accomodations.skipass_currently_discounted">

      <p class="notice" v-if="false">
        <span v-if="!skipassBlocked"><span v-html="'* ' + SITE_CONFIG.accomodations.skipass_currently_discounted_text"></span><br /></span>
        * <b>Vi bjuder</b> på kostnaden för kortet (ord. pris 55:-/st) när du bokar boende (gäller hela säsongen, kan inte läggas till i efterhand).
      </p>

      <div class="" v-if="skipassBlocked">
        <div style="clear:both;"></div>
        <p class="">Just nu erbjuder vi 10% rabatt på liftkort när du bokar för hela boende-perioden. <b>Ring oss på</b> <a href="tel:054-13 26 00">054-13 26 00</a> senast den {{ SITE_CONFIG.accomodations.skipass_currently_discounted_pretty_date }} för att ta del av erbjudandet.</p>
        <p>&nbsp;</p>
      </div>
      <div class="space center bt-wrapper" v-if="skipassBlocked">
        <button class="" @click="closeModal()">Okej</button>
      </div>

    </div>

    <div v-if="!SITE_CONFIG.accomodations.skipass_currently_discounted">
      <div style="clear:both;"></div>
      <p class="notice" v-if="skipassBlocked"><b>Ring oss på</b> <a href="tel:054-13 26 00">054-13 26 00</a> för att boka liftkort till detta boende.</p>
      <div class="space center bt-wrapper" v-if="skipassBlocked">
        <button class="" @click="closeModal()">Okej</button>
      </div>
    </div>

  </Modal>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Timeline from '@/components/components/Timeline';
import SwitchButton from '@/components/components/SwitchButton';
import Loading from '@/components/components/Loading';
import Dropdown from '@/components/components/Dropdown';
import Checkbox from '@/components/components/Checkbox';
import API from '@/classes/API';

export default {
  name: 'addonspage',
  components: {
    Modal,
    Timeline,
    SwitchButton,
    Checkbox,
    Dropdown,
    Loading,
  },
  data() {
    return {
      cartAccomodationObject: {},
      cartSkipassObject: {},
      showingSkipassModal: false,
      adultDays: 0,
      seniorDays: 0,
      youthDays: 0,
      childrenDays: 0,
      adults: 0,
      youths: 0,
      children: 0,
      addons: [],
      adultPricelistPrice: 0,
      seniorPricelistPrice: 0,
      youthPricelistPrice: 0,
      childPricelistPrice: 0,
      adultOriginalPrice: 0,
      seniorOriginalPrice: 0,
      youthOriginalPrice: 0,
      childOriginalPrice: 0,
      keycardPrice: 0,
      cancellationInsurance: null,
      markInsurance: false,
      cancellationInsuranceObject: {},
      lateArrivalObject: {},
      adultLid: null,
      youthLid: null,
      seniorLid: null,
      childLid: null,
      loading: false,
      skipassBlocked: false,
      deliveryAllowed: false,
      discount_date: null,
      discount_date_pretty: null,
      delivery_type: 'delivery',
      site: '',
    };
  },
  mounted() {
    this.discount_date = '30/9 2019';
    this.discount_date_pretty = '30 september';

    if (this.SITE_CONFIG.site === 'kungsberget') {
      this.discount_date = '31/10 2019';
      this.discount_date_pretty = '31 oktober';
    }

    const currentAccomodationIndex = this.accomodationIndex;

    if (this.$route.name === 'addons') {
      this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];
    } else {
      this.cartAccomodationObject = {
        poolLid: this.$route.query.pool,
        unitLid: this.$route.query.unit,
        name: this.$route.query.name,
        period: {
          date_arrival: this.$route.query.arrival,
          date_departure: this.$route.query.departure,
        },
        adults: parseInt(this.$route.query.adults, 10),
        youths: parseInt(this.$route.query.youths, 10),
        seniors: parseInt(this.$route.query.seniors, 10),
        children: parseInt(this.$route.query.children, 10),
      };
    }

    if (this.cartAccomodationObject && this.cartAccomodationObject.site) {
      if (this.cartAccomodationObject.site === 2007) {
        this.site = 'by';
      } else if (this.cartAccomodationObject.site === 2006) {
        this.site = 'berg';
      }
    }

    let currentSkipassIndex = -1;
    this.cart.skipasses.forEach((skipass, index) => {
      if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === currentAccomodationIndex) {
        currentSkipassIndex = index;
      }
    });

    if (currentSkipassIndex === -1) {
      this.addAccomodationSkipasses({
        days: this.noOfDays(),
        adults: this.cartAccomodationObject.adults || 0,
        seniors: this.cartAccomodationObject.seniors || 0,
        youths: this.cartAccomodationObject.youths || 0,
        children: this.cartAccomodationObject.children || 0,
        belongsTo: currentAccomodationIndex,
      });

      currentSkipassIndex = 0;
    }
    this.cartSkipassObject = this.cart.skipasses[currentSkipassIndex];
    if (this.cartSkipassObject.seniors === null) {
      this.cartSkipassObject.seniors = 0;
    }

    this.getAddons();
  },
  computed: {
    ...mapGetters([
      'cart',
    ]),
    accomodationIndex() {
      if (typeof this.$route.query.no === 'undefined') {
        return 0;
      }
      const no = parseInt(this.$route.query.no, 10);

      if (no === -2) {
        return null;
      }

      if (!no) {
        return 0;
      }

      if (isNaN(no)) {
        return 0;
      }

      return no;
    },
    skiPassAccomodationAfterCheckinText() {
      return 'Efter incheckning i boendet. Liftkorten levereras med nycklarna.';
    },
    skiPassAccomodationBeforeCheckinText() {
      return 'Före incheckning i boendet. Liftkorten hämtas i skidhyran.';
    },
  },
  methods: {
    validated() {
      if (this.cancellationInsurance === true) {
        return true;
      } else if (this.cancellationInsurance === false) {
        return true;
      }
      return false;
    },
    async getAddons() {
      this.$nextTick(() => {
        if (!this.loading) {
          this.loading = true;
        }
      });

      let url = `/units/${this.cartAccomodationObject.poolLid}/${this.cartAccomodationObject.unitLid}/addons/${this.cartAccomodationObject.period.date_arrival}/${this.cartAccomodationObject.period.date_departure}`;

      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric) {
        url = `${url}?order=${this.$store.state.cart.addToOrder.numeric}&order-line-group=${this.$store.state.cart.addToOrder.accomodationGroup}`;
      }
      const { data, meta_skipasses,
        cancellationInsurance, lateArrival, keycardPrice, deliveryAllowed } = await API.get(url);

      if (deliveryAllowed) {
        this.deliveryAllowed = true;
        this.delivery_type = 'delivery';
      } else {
        this.deliveryAllowed = false;
        this.delivery_type = 'pickup';
      }

      if (this.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) {
        this.deliveryAllowed = false;
        this.delivery_type = 'pickup';
      }

      this.addons = data.map((addon) => {
        let start = parseInt(addon.min_qty, 10);
        const end = parseInt(addon.max_qty, 10);

        const a = addon;
        a.options = [];
        while (start <= end) {
          if (!start) {
            a.options.push({ title: 'ANTAL', value: 0 });
          } else {
            a.options.push({ title: `${start} st`, value: start });
          }
          start += 1;
        }
        return a;
      });

      this.lateArrivalObject = lateArrival;
      this.cancellationInsuranceObject = cancellationInsurance;

      if (meta_skipasses.adult.separate_days) {
        this.adultPricelistPrice = Math.round(
          parseFloat(meta_skipasses.adult.separate_days.aprice, 10),
        );
        this.adultLid = meta_skipasses.adult.separate_days.lid;
        this.adultOriginalPrice = meta_skipasses.adult.separate_days.original;
      } else if (meta_skipasses.adult.week) {
        this.adultPricelistPrice = Math.round(
          parseFloat(meta_skipasses.adult.week.aprice, 10),
        );
        this.adultLid = meta_skipasses.adult.week.lid;
        this.adultOriginalPrice = meta_skipasses.adult.week.original;
      } else {
        this.adultPricelistPrice = 0;
        this.adultOriginalPrice = 0;
      }

      if (meta_skipasses.senior && meta_skipasses.senior.separate_days) {
        this.seniorPricelistPrice = Math.round(
          parseFloat(meta_skipasses.senior.separate_days.aprice, 10),
        );
        this.seniorLid = meta_skipasses.senior.separate_days.lid;
        this.seniorOriginalPrice = meta_skipasses.senior.separate_days.original;
      } else if (meta_skipasses.senior && meta_skipasses.senior.week) {
        this.seniorPricelistPrice = Math.round(
          parseFloat(meta_skipasses.senior.week.aprice, 10),
        );
        this.seniorLid = meta_skipasses.senior.week.lid;
        this.seniorOriginalPrice = meta_skipasses.senior.week.original;
      } else {
        this.seniorPricelistPrice = 0;
        this.seniorOriginalPrice = 0;
        this.cartSkipassObject.seniors = 0;
      }

      if (meta_skipasses.youth.separate_days) {
        this.youthPricelistPrice = Math.round(
          parseFloat(meta_skipasses.youth.separate_days.aprice, 10),
        );
        this.youthLid = meta_skipasses.youth.separate_days.lid;
        this.youthOriginalPrice = meta_skipasses.youth.separate_days.original;
      } else if (meta_skipasses.youth.week) {
        this.youthPricelistPrice = Math.round(
          parseFloat(meta_skipasses.youth.week.aprice, 10),
        );
        this.youthLid = meta_skipasses.youth.week.lid;
        this.youthOriginalPrice = meta_skipasses.youth.week.original;
      } else {
        this.youthPricelistPrice = 0;
        this.youthOriginalPrice = 0;
      }

      if (meta_skipasses.child.separate_days) {
        this.childPricelistPrice = Math.round(
          parseFloat(meta_skipasses.child.separate_days.aprice, 10),
        );
        this.childLid = meta_skipasses.child.separate_days.lid;
        this.childOriginalPrice = meta_skipasses.child.separate_days.original;
      } else if (meta_skipasses.child.week) {
        this.childPricelistPrice = Math.round(
          parseFloat(meta_skipasses.child.week.aprice, 10),
        );
        this.childLid = meta_skipasses.child.week.lid;
        this.childOriginalPrice = meta_skipasses.child.week.original;
      } else {
        this.childPricelistPrice = 0;
        this.childOriginalPrice = 0;
      }

      this.cartSkipassObject.adultsPrice = this.adultPricelistPrice;
      this.cartSkipassObject.seniorsPrice = this.seniorPricelistPrice;
      this.cartSkipassObject.youthsPrice = this.youthPricelistPrice;
      this.cartSkipassObject.childrenPrice = this.childPricelistPrice;

      this.keycardPrice = keycardPrice;
      if (!this.adultPricelistPrice || !this.youthPricelistPrice) {
        this.closeModal();
      }

      this.loading = false;
    },
    ...mapMutations([
      'confirmSkipasses',
      'unconfirmSkipasses',
      'addAddon',
      'removeAddon',
      'addSkipasses',
      'addAccomodationSkipasses',
      'openModal',
      'closeModal',
    ]),
    chooseArticle(addon) {
      if (addon.qtySelected) {
        addon.added = true; // eslint-disable-line no-param-reassign
        this.addAddon(addon);
      } else {
        this.openModal(['GeneralModal', {
          title: 'Välj antal',
          content: '<p>Du måste välj hur många du vill ha.</p>',
        }]);
      }
    },
    removeArticle(addon) {
      addon.added = false; // eslint-disable-line no-param-reassign
      this.removeAddon(addon);
    },
    infoPopup(addon) {
      this.openModal(['AddonInfoModal', {
        addon,
      }]);
    },
    next() {
      const $this = this;
      if (this.validated()) {
        if (!this.cancellationInsurance) {
          this.openModal(['GeneralModal', {
            title: 'Avbeställningsskydd',
            content: '<p>Du har tackat <b>nej</b> till av- och ombokningsförsäkring.</p><p>Du har då inte möjlighet att: byta boende boka om till annan period eller avboka och få pengarna tillbaka enligt gällande bokningsvillkor.</p>',
            buttons: [
              {
                title: 'Jag vill ändra',
                class: 'small white border',
                click: () => {
                  $this.closeModal();
                },
              },
              {
                title: 'Jag förstår',
                class: 'small',
                click: () => {
                  $this.closeModal();
                  $this.openModal(['CartHighFiveModal', {}]);
                },
              },
            ],
          }]);
        } else {
          this.openModal(['CartHighFiveModal', {}]);
        }
      } else {
        this.openModal(['GeneralModal', {
          title: 'Vill du ha Avbeställningskydd?',
          content: '<p>Du behöver ta ställning till om du vill ha avbeställningsskydd eller inte.</p>',
          buttons: [
            {
              title: 'Okej, låt mig välja',
              class: 'small',
              click: () => {
                $this.markInsurance = true;
                $this.closeModal();
              },
            },
          ],
        }]);
      }
    },
    openLateCheckinInfo() {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: 'Sen incheckning',
        content: '<p>Sen incheckning, från 17. Pris 0:-</p><p>Lorem ipsum orem ipsum orem ipsum orem ipsum. Lorem ipsum orem ipsum orem ipsum orem ipsum.',
        buttons: [
          {
            title: 'Okej',
            class: 'small',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    adultPrice(includeKeycard) {
      const price = this.cartSkipassObject.adults * this.adultPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - (this.cartSkipassObject.adults * this.keycardPrice);
      }

      return 0;
    },
    seniorPrice(includeKeycard) {
      const price = (this.cartSkipassObject.seniors || 0) * this.seniorPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - ((this.cartSkipassObject.seniors || 0) * this.keycardPrice);
      }

      return 0;
    },
    youthPrice(includeKeycard) {
      const price = this.cartSkipassObject.youths * this.youthPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - (this.cartSkipassObject.youths * this.keycardPrice);
      }

      return 0;
    },
    childPrice(includeKeycard) {
      const price = this.cartSkipassObject.children * this.childPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - (this.cartSkipassObject.children * this.keycardPrice);
      }

      return 0;
    },
    keycardTotalPrice() {
      const qty = parseInt(this.cartSkipassObject.adults, 10)
        + parseInt(this.cartSkipassObject.youths, 10)
        + parseInt(this.cartSkipassObject.children, 10)
        + parseInt(this.cartSkipassObject.seniors || 0, 10);

      const price = this.keycardPrice * qty;

      if (price) {
        return price;
      }

      return 0;
    },
    totalPrice() {
      return this.adultPrice(true) + this.youthPrice(true)
        + this.childPrice(true) + this.seniorPrice(true);
    },
    originalPrice() {
      // const people = this.noOfSkipasses();
      // return (this.cartSkipassObject.adults * this.adultOriginalPrice)
      //   + (this.cartSkipassObject.youths * this.youthOriginalPrice)
      //   + (this.cartSkipassObject.children * this.childOriginalPrice)
      //   + (people * this.keycardPrice);
      return (this.adultPrice(true) + this.youthPrice(true)
        + this.childPrice(true) + this.seniorPrice(true)) / 0.9;
    },
    noOfSkipasses() {
      const skipasses = parseInt(this.cartSkipassObject.adults, 10) +
        parseInt(this.cartSkipassObject.seniors, 10) +
        parseInt(this.cartSkipassObject.youths, 10) +
        parseInt(this.cartSkipassObject.children, 10);

      if (skipasses) {
        return skipasses;
      }

      return 0;
    },
    noOfDays() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        const a = moment(this.cartAccomodationObject.period.date_arrival);
        const b = moment(this.cartAccomodationObject.period.date_departure);

        const premiereStart = this.SITE_CONFIG.season.winter.premiere_weekend_start;
        const premiereEnd = this.SITE_CONFIG.season.winter.premiere_weekend_end;

        const extraPremiereActive = this.SITE_CONFIG.season.winter.extra_premiere_weekend_active;
        const extraPremiereStart = this.SITE_CONFIG.season.winter.extra_premiere_weekend_start;
        const extraPremiereEnd = this.SITE_CONFIG.season.winter.extra_premiere_weekend_end;

        // See also backend comment "PREMIERE WEEKEND DATES"
        if (a.format('YYYY-MM-DD') === premiereStart && b.format('YYYY-MM-DD') === premiereEnd) {
          return b.diff(a, 'days');
        }

        if (extraPremiereActive && a.format('YYYY-MM-DD') === extraPremiereStart && b.format('YYYY-MM-DD') === extraPremiereEnd) {
          return b.diff(a, 'days');
        }

        return b.diff(a, 'days') + 1;
      }

      return 0;
    },
    cartSkipasses() {
      const currentAccomodationIndex = this.accomodationIndex;
      let currentSkipassIndex = -1;
      let accObject = Object.assign({}, this.cartAccomodationObject);

      if (this.$route.name === 'addons') {
        this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];

        this.cart.skipasses.forEach((skipass, index) => {
          if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === currentAccomodationIndex) {
            currentSkipassIndex = index;
          }
        });

        accObject = Object.assign({}, {
          pool_lid: this.cartAccomodationObject.poolLid,
          unit_lid: this.cartAccomodationObject.unitLid,
          name: this.cartAccomodationObject.name,
        });
      } else {
        currentSkipassIndex = 0;

        accObject = Object.assign({}, {
          pool_lid: this.cartAccomodationObject.poolLid,
          unit_lid: this.cartAccomodationObject.unitLid,
          name: this.cartAccomodationObject.name,
        });
      }

      this.confirmSkipasses({
        index: currentSkipassIndex,
        adultLid: this.adultLid,
        seniorLid: this.seniorLid,
        youthLid: this.youthLid,
        childLid: this.childLid,
        days: this.noOfDays(),
        deliveryType: this.delivery_type,
        deliveryTo: {
          pool_lid: accObject.pool_lid,
          unit_lid: accObject.unit_lid,
          name: accObject.name,
        },
        site: this.site,
      });
      this.closeModal();
    },
    removeSkipasses() {
      this.unconfirmSkipasses();
    },
    modalSkipasses() {
      this.showingSkipassModal = true;
    },
    addSkipassToCart(age, days, number) {
      this.addSkipasses({ age, days, number });
    },
    toggleLate(v) {
      const obj = this.lateArrivalObject;
      obj.title = 'Sen ankomst';
      obj.qtySelected = 1;

      if (v.value) {
        this.addAddon(obj);
      } else {
        this.removeAddon(obj);
      }
    },
    validatedSkipasses() {
      if (this.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) {
        return this.noOfSkipasses();
      }

      const siteOkay = this.delivery_type === 'delivery' || this.site;
      return this.noOfSkipasses() && siteOkay;
    },
    unmarkInsuranceError() {
      this.markInsurance = false;

      const obj = this.cancellationInsuranceObject;
      obj.title = 'Avbeställningskydd';
      obj.qtySelected = 1;

      if (this.cancellationInsurance) {
        this.addAddon(obj);
      } else {
        this.removeAddon(obj);
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.keycard-splasch
  position: absolute;
  background: brick;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  right: -20px;
  top: -15px;
  font-size: 18px
  padding: 35px 10px 10px 10px
  text-align: center;
  font-family  "UnitedSerifCond Heavy"
  font-weight: 900
  color: #fff
  transform: rotate(9deg);
  border: 3px solid #fff
  line-height: 1.1em
  .larger
    font-size 115%
  +max-mobile()
    right: 20px
  +max-xs-mobile()
    position: relative;
    margin: 0 auto
    right: 0px;
    transform: rotate(5deg);
    font-size: 15px
    width: 100px
    height: 100px



.disabled
  disabled()

.outline-button
  border-radius 4px
  background-color #ffffff
  border solid 1px light-blue-grey
  font-family Interstate
  font-size 11px
  font-weight bold
  color deep-sea-blue
  text-transform uppercase
  text-decoration none
  padding 5px 8px
  display inline-block

.bt-wrapper
  max-width: 350px;
  margin: 7px auto;

button
  font-size 11px
  padding 12px 15px 6px
  margin-left: 5px
  margin-right: 5px
  margin-bottom: 10px
  +max-mobile()
    margin-bottom: 10px
.small-key
    background-color brick
    font-size 9px
    padding 8px 11px 3px
    position: relative
    top: 2px
    border-bottom: 5px solid dark-red
    &:hover
      background-color dark-red
      border-bottom: 5px solid brick
h1
  text-align center
  text-transform none
  font-size 30px
  font-weight 900
  text-align center
  color #1c1c1c
  margin-bottom 3px
h2
  font-family  "UnitedSerifCond Heavy"
  font-weight: 900
  font-size 21px
  font-weight 900
  color #1c1c1c
ul
  margin-top 10px
  margin-bottom 10px
  padding-left: 20px
  li
    list-style disc
    margin-bottom 10px
    font-size 14px
    font-weight 300
    list-style-image url(https://static.booking.branasgruppen.se/static/svg/punklista-check.svg)
.ingress
  font-size 18px
  font-weight 300
  text-align center
  color #262626
.skipass-holder
  max-width:890px
  margin 0 auto
  border-radius 2px
  background-color #ffffff
  // box-shadow 0 0 8px 0 rgba(0, 0, 0, 0.14)
  display flex
  .padded
    padding 25px
    width calc(100% - 160px)
    // float left

input
  width 2.1em !important
  padding 3px 5px
  border-radius 3px
  background-color #ffffff
  border solid 1px light-blue-grey
  text-align center
  &[readonly]
    border-color transparent
    background-color transparent

.image
  padding-top 160px
  width 160px
  float left
  //background-color rgba(225, 239, 243, 0.3)
  background-image url('https://static.booking.branasgruppen.se/static/img/liftkort.png')
  background-size 80%
  background-repeat no-repeat
  background-position center

.space
  margin-top space-2
  +max-mobile()
    margin-top: 5px

.skipass-table
  border-left solid 1px light-blue-grey
  border-right solid 1px light-blue-grey
  border-radius 4px 4px 0px 0px
  border-radius 4px
  display table-cell
  th
    border-radius 4px 4px 0px 0px
    background-color rgba(0, 85, 128, 0.85)
    padding 6px 10px
    color white
    font-size 11px
    font-weight bold
    position relative
    top -2px
    span
      font-size 11px
      font-weight 300
  td
    font-family Interstate
    font-size 13px
    font-weight 300
    color #262626
    padding 4px 10px
    border-radius 2px
    background-color rgba(236, 245, 248, 0.3)
    border-bottom solid 1px light-blue-grey
    &.children-price,
    &.keycard-price
      & > *
        font-size: 10px
        background-color: gold
        padding: 4px 6px
        border-radius: 2px
        color: #fff;
    span
      font-size 10px
  td:nth-child(1)
    width 3em
    height: 35px
  td:nth-child(2)
    width 50%
    padding 0 10px
  td:nth-child(3)
    width 150px
  .summarizer
    .smaller
      font-size 11px
      color #9e9e9e
    b
      font-size 17px
      font-weight bold
      color: black
  .offsetter
    margin-left -25px

.addons
  max-width:890px
  margin 0 auto
  margin-top space-3
  margin-bottom space-3
  padding-bottom space-3
  padding-top space-3
  h2
    margin-bottom space-2
  .list
    display flex
    flex-wrap wrap
    justify-content center
    .addon
      border-radius 2px
      background-color #ffffff
      box-shadow 0 0 8px 0 rgba(0, 0, 0, 0.14)
      width 30%
      margin-left: 1.6%
      margin-right: 1.6%
      margin-bottom 3%
      padding 5px
      border: solid 3px white;
      &.selected
        border-color #c7dcb7
      .addon-image
        height 122px
        border-radius 2px
        background-color rgba(225, 239, 243, 0.3)
        background-image url('https://static.booking.branasgruppen.se/static/img/helmet.png')
        background-size 40%
        background-repeat no-repeat
        background-position center
      b
        font-size 13px
        line-height: 1.2em
        font-weight bold
        margin-top 8px
        margin-bottom: 5px
        display block
      /*button,
      .dropdown-wrapper
        float left
        margin-left 5px*/

.cancellation-insurance
  border-radius 2px
  background-color rgba(236, 245, 248, 0.5)
  border solid 1px light-blue-grey
  padding 18px 200px
  max-width:890px
  margin 0 auto
  margin-top 20px
  position relative
  .required-notice
    position absolute
    top 15px
    right 15px
    font-size: 12px;
    font-weight: 300;
    color: #1c1c1c;
    span
      font-size: 14px;
      color: #ae1116;
      vertical-alignt super
  h3
    font-family Interstate
    font-size 17px
    font-weight bold
    color #262626
    em
      font-style normal
      font-size 26px
      font-weight bold
      letter-spacing 0.3px
      color #262626
  p
    font-size 13px
    font-weight 300
    line-height 1.38
    color #1c1c1c
    margin-bottom 1.3em

.checkbox-wrapper
  float left
  margin-right 20px
  text-align center

.spacing
  margin-top space-3
  margin-bottom space-3


.SwitchButton
  border 0
  padding 0
  background-color transparent
  display inline-block

select
  border-radius 4px
  background-color pale-grey
  border solid 1px light-blue-grey
  font-size 11px
  font-weight bold
  letter-spacing 0.3px
  color deep-sea-blue
  text-transform uppercase
  padding 6px
  margin: 0px 8px

.float-left
  float left
  margin-right 2px
  margin-left 3px
.float-right
  float right
  margin-left 2px
  margin-right 3px

.center > div
  display inline-block
  text-align: left

.notice
  margin 25px 20px 0 20px
  width: calc(100% - 80px)
  font-size 13px

.info-wrapper
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  background-color: rgba(236,245,248,.3);
  margin-left: -45px;
  width: calc(100% + 90px);
  padding-left: 25%;
  padding-right: 25%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  h2
    font-size 21px
    width: 100%

  div
    width 100%
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

  hr
    width 100%
</style>



// WEBPACK FOOTER //
// AccomodationSkipass.vue?1ec18434